module.exports = __webpack_public_path__ + "images/tesla31b44d5fdae03025f3eefa1547ba38ef.png";